import React from 'react';
import { Settings as SettingsIcon, CreditCard, Percent, Clock } from 'lucide-react';
import DepositSettings from '../../features/settings/components/DepositSettings';
import TaxSettings from '../../features/settings/components/TaxSettings';
import TimezoneSettings from '../../features/settings/components/TimezoneSettings';
import ServicesOfferedConfig from '../../features/settings/components/ServicesOfferedConfig';

const AppConfig = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3">
        <SettingsIcon className="h-6 w-6 text-primary" />
        <div>
          <h2 className="text-2xl font-bold text-secondary">App Configuration</h2>
          <p className="text-sm text-muted-foreground">Configure application-wide defaults and preferences.</p>
        </div>
      </div>

      {/* Services Offered — controls which calculator cards this business shows */}
      <ServicesOfferedConfig />

      {/* Timezone */}
      <section data-testid="timezone-settings-wrapper">
        <div className="flex items-center gap-2 mb-4">
          <Clock className="w-5 h-5 text-gray-500" />
          <h3 className="text-base font-semibold text-gray-900">Timezone</h3>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
          <TimezoneSettings />
        </div>
      </section>

      {/* Tax Settings */}
      <section data-testid="tax-settings-wrapper">
        <div className="flex items-center gap-2 mb-4">
          <Percent className="w-5 h-5 text-gray-500" />
          <h3 className="text-base font-semibold text-gray-900">Tax</h3>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
          <TaxSettings />
        </div>
      </section>

      {/* Deposit / Invoice Settings */}
      <section data-testid="deposit-settings-section">
        <div className="flex items-center gap-2 mb-4">
          <CreditCard className="w-5 h-5 text-gray-500" />
          <h3 className="text-base font-semibold text-gray-900">Deposit & Invoicing</h3>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
          <p className="text-sm text-gray-500 mb-5">
            Configure automatic deposit invoices when jobs are scheduled from approved quotes.
            A final invoice for the remaining balance is created automatically when the job is marked complete.
          </p>
          <DepositSettings />
        </div>
      </section>

    </div>
  );
};

export default AppConfig;
